// Utility to fetch and parse CSV into JSON
export async function fetchCsvAsJson(url: string): Promise<any[]> {
  const response = await fetch(url);
  if (!response.ok) {
    throw new Error(`Failed to fetch CSV: ${response.statusText}`);
  }
  const text = await response.text();
  const lines = text.trim().split('\n');
  if (lines.length === 0) return [];
  const headers = lines[0].split(',');
  return lines.slice(1).map(line => {
    const values = line.split(',');
    const obj: Record<string, any> = {};
    headers.forEach((header, i) => {
      let value: any = values[i];
      // Try to parse as number if possible
      if (!isNaN(Number(value)) && value !== "") {
        value = Number(value);
      }
      obj[header] = value;
    });
    return obj;
  });
}

// Helper to get the backend proxy URL for an image (if needed elsewhere, move here)

// Fetch bitmap image paths from the backend
export function fetchBitmapImages(URL_SERVER: string, localPath: string, setBitmapImages: (imgs: string[]) => void) {
  fetch(`${URL_SERVER}/api/images?bucketPath=${encodeURIComponent(localPath)}`)
    .then(res => res.json())
    .then((files: string[]) => {
      // Files are already full paths returned from the server
      console.log('! bitmapImages', localPath, files);
      setBitmapImages(files);
    });
}

// Preload images as HTMLImageElement objects with retry logic
export function preloadImages(urls: string[], callback: (images: HTMLImageElement[]) => void, maxRetries: number = 2, retryDelay: number = 3000) {
  let loaded: HTMLImageElement[] = [];
  let count = 0;
  const retryCounts: number[] = new Array(urls.length).fill(0);

  const attemptLoad = (url: string, index: number) => {
    const img = new window.Image();
    img.crossOrigin = "anonymous";
    img.onload = () => {
      loaded[index] = img;
      count++;
      if (count === urls.length) callback(loaded);
    };
    img.onerror = () => {
      // Retry failed images after a delay
      if (retryCounts[index] < maxRetries) {
        retryCounts[index]++;
        console.log(`Retrying image ${index} (attempt ${retryCounts[index]}/${maxRetries}) after ${retryDelay}ms: ${url}`);
        setTimeout(() => {
          attemptLoad(url, index);
        }, retryDelay);
      } else {
        // Max retries reached, give up
        console.warn(`Failed to load image after ${maxRetries} retries: ${url}`);
        loaded[index] = img; // still push the image, even if errored
        count++;
        if (count === urls.length) callback(loaded);
      }
    };
    img.src = url;
  };

  urls.forEach((url, i) => {
    attemptLoad(url, i);
  });
}

// Fetch bitmap images with error and loading state handling
export function fetchBitmapImagesWithError(
  URL_SERVER: string,
  localPath: string,
  setBitmapImages: (imgs: string[]) => void,
  setError: (err: boolean) => void,
  setLoading: (loading: boolean) => void
) {
  fetch(`${URL_SERVER}/api/images?bucketPath=${encodeURIComponent(localPath)}`)
    .then(res => res.json())
    .then((files: string[]) => {
      // Files are already full paths returned from the server
      if (files.length === 0) {
        setError(true);
        setLoading(false);
      } else {
        setError(false);
      }
      console.log('! bitmapImages', localPath, files);
      setBitmapImages(files);
    })
    .catch(() => {
      setError(true);
      setLoading(false);
      setBitmapImages([]);
    });
}
